<template>
  <div>
    <navbar/>
    <error-panel showInPopup="false" />
    <Spinner :loaded="loaded" />
    <main role="main" v-if="loaded">
        <div class="jumbotron" id="tl-jumbotron">
          <div class="container">
            <div class="row tl-link-block tl-link-block-header pb-1 mb-3">
              <h4 class="col-10" v-if="tag">
                <span class="bi bi-person-circle tl-user-profile-icon mr-2"></span>
                <a class="tl-link tl-user-header" :href="'/bookmarks/'+owner">{{owner}}</a>
                <span class="tl-breadcrumb-separator"> » </span>
                <span class="">{{tag}}</span>
                <div>
                  <span class="tl-subtext-header">{{owner}}'s bookmarks tagged as {{tag}}</span>
                </div>
              </h4>

              <h4 class="col-10" v-if="!tag">
                <span class="bi bi-person-circle tl-user-profile-icon mr-2"></span>
                <a class="tl-link tl-user-header" :href="'/bookmarks/'+owner">{{owner}}</a>
                <span class="tl-breadcrumb-separator"> » </span>
                <span class="">all</span>
                <div>
                  <span class="tl-subtext-header">{{owner}}'s bookmarks</span>
                </div>
              </h4>
              <div class="col-2" style="text-align: right">
                <PagePermaLink/>
              </div>
            </div>

          <EmptyState v-if="!tag && !hasLinks && canEditLinks"/>

          <div data-title="emptyState" v-if="(tag && !hasLinks) || (!tag && !canEditLinks && !hasLinks)" class="row tl-link-block p-4">
            <div class="col-sm-1 d-none d-sm-block">
                <i class="bi bi-emoji-astonished tl-emptystate-icon"></i>
            </div>
            <div class="col-sm-9 col-12">
              <div class="tl-link-title">
                  There doesn't seem to be anything here...
              </div>
              <div class="tl-link-small mt-3">
                  Could be a typo in the username or tag?
              </div>
            </div>
              <div class="col-sm-2 col-12 pt-4 pt-sm-0"><i class="bi bi-question-circle"></i><a href="/help"> Need help?</a></div>
          </div>

            <LinkList v-if="hasLinks" :links="links" :owner="owner"/>

            <!-- TODO: replace with PageNavigation component -->
            <nav v-if="hasLinks" aria-label="Page navigation">
              <ul class="pagination justify-content-between">
                <li data-component="prevLink" :class="prevPageNumber ? 'page-item' : 'page-item disabled'">
                  <a class="page-link" href="#" @click="navigate(prevPageNumber, $event)">
                    <span aria-hidden="true">&laquo;</span>
                    Previous</a>
                </li>
                <li data-component="nextLink" :class="nextPageNumber ? 'page-item' : 'page-item disabled'">
                  <a class="page-link" href="#" @click="navigate(nextPageNumber, $event)">
                    Next
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </main>
    <tlfooter v-if="loaded"/>
  </div>
</template>

<script>
import BackendClient from "@/rest/backend-client";
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import ErrorPanel from "@/components/ErrorPanel";
import PagePermaLink from "@/components/PagePermaLink";
import EmptyState from "@/components/EmptyState";
import Spinner from "@/components/Spinner";
import LinkList from "@/components/LinkList";

export default {
  name: "Links",
  head() {
      let title = `just bookmark it! - ${this.owner}'s bookmarks`
      if (this.tag) {
        title = title + ` tagged as ${this.tag}`;
      }
      return { title }
  },
  components: {
    ErrorPanel, navbar, tlfooter, PagePermaLink, EmptyState, Spinner, LinkList
  },
  data() {
    return {
      loaded: false,
      links: null,
      prevPageNumber: null,
      nextPageNumber: null,
      selectedLink: null,
      backendClient: new BackendClient()
    }
  },
  props: ['owner', 'tag', 'page'],
  mounted () {
    this.initializeBootstrapComponents();
   this.backendClient.getLinks(this.owner, this.tag, this.page).then(responseData => {
      this.links = responseData.links;
      this.prevPageNumber = responseData.prevPageNumber;
      this.nextPageNumber = responseData.nextPageNumber;
      this.loaded = true;
    });
  },
  computed: {
    canEditLinks: function() {
      return this.$store.state.userLoggedIn
        && this.owner === this.$store.state.loggedInUserName;
    },
    hasLinks() {
      return this.links && this.links.length > 0;
    }
  },
  methods: {
    initializeBootstrapComponents() {
      // eslint-disable-next-line
      $(function () {
        // eslint-disable-next-line
        $('[data-toggle="tooltip"]').tooltip()
      })
    },
    navigate(pageNumber, event){
      event.preventDefault();
      let routeName = this.tag ? "linksByOwnerAndTag" : "linksByOwner";
      this.$router.push({ name: routeName, params: {page: pageNumber, tag: this.tag, owner: this.owner} });
    }
  }
}
</script>

<style scoped>

</style>
